export default "__VITE_ASSET__088fd324__"